// Agent portal routes (agents.logeco.africa). Mounted ONLY on the agent host
// (see router/index.js). Offer-side only: AI content sourcing + dashboard.
const meta = { agent: true, requiresAgentAuth: true }
const ingestMeta = (entity) => ({ ...meta, entity, portal: 'agent', draftOnly: true })

export default [
  { path: '/agent/login', name: 'AgentLogin', component: () => import('../views/agent/AgentLogin.vue'), meta: { agent: true } },
  { path: '/agent/change-password', name: 'AgentChangePassword', component: () => import('../views/agent/AgentChangePassword.vue'), meta },
  {
    path: '/agent',
    component: () => import('../views/agent/AgentLayout.vue'),
    meta,
    children: [
      { path: '', name: 'AgentDashboard', component: () => import('../views/agent/AgentDashboard.vue'), meta },
      { path: 'capture/opportunities', name: 'AgentCaptureOpportunities', component: () => import('../views/admin/AdminIngest.vue'), meta: ingestMeta('opportunities') },
      { path: 'capture/schools', name: 'AgentCaptureSchools', component: () => import('../views/admin/AdminIngest.vue'), meta: ingestMeta('schools') },
      { path: 'capture/guides', name: 'AgentCaptureGuides', component: () => import('../views/admin/AdminIngest.vue'), meta: ingestMeta('guides') },
    ],
  },
  { path: '*', redirect: '/agent' },
]
